import { DefaultOptions, useQuery } from "@tanstack/react-query";

import { getAllReservationPolicyListAsync } from "src/api/product/product-api";
import { ReservationPolicyOwner, ReservationPolicyType } from "src/api/product/product-types";
import { axiosInstance } from "src/utils";

export const RESERVATION_POLICY_QUERY_KEY = "getReservationPolicyListAsync";

/**
 * 공용공간 예약 정책 조회 - RRVP03/09
 *
 * 상품/계약 하나의 해당 정책을 전부(기본 정책 + 공간별 개별 정책) 받아온다.
 * facilityType 으로 걸러 받으면 개별 공간 정책이 빠질 수 있어(scope 에 facilityType 이 없을 수 있음)
 * 전부 받아온 뒤 scope 로 골라 쓴다.
 *
 * @returns ReservationPolicyModel[]
 */
const useGetReservationPolicy = ({
  owner,
  policyType,
  defaultOptions,
}: {
  owner: ReservationPolicyOwner;
  policyType: ReservationPolicyType;
  defaultOptions?: DefaultOptions["queries"];
}) => {
  const _defaultOptions = defaultOptions as unknown as Object;
  const hasOwner = !!owner?.productId || !!owner?.contractManageId;

  const query = useQuery({
    // 호출부가 id 를 문자열로 넘기든 숫자로 넘기든 같은 캐시를 쓰도록 정규화한다
    queryKey: [RESERVATION_POLICY_QUERY_KEY, policyType, String(owner?.productId ?? ""), String(owner?.contractManageId ?? "")],
    queryFn: () => getAllReservationPolicyListAsync(axiosInstance, { ...owner, policyType }),
    enabled: hasOwner,
    ...(_defaultOptions && _defaultOptions),
  });

  return { ...query };
};

export default useGetReservationPolicy;
